Namespace 'Customer.Dashboard'
DASHBOARD_VIEW = 'Welcome'

class Customer.Dashboard.PrincipalView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/principal']

  events:
    'click #principal-selector' : 'onPrincipalShortcut'

  initialize: (@options = {}) ->
    @tabViews = @options.tabViews || throw new Error('Cannot instantiate a TabListView without tabViews')
    @tabManagerView = @options.tabManagerView || throw new Error('Cannot instantiate tabManagerView')

  render: ->
    @$el.html(@template)
    @

  onPrincipalShortcut: ->
    _.each(@tabViews, (tabView) =>
      if tabView.tabId() == DASHBOARD_VIEW
        @tabManagerView.onSelectTab(tabView.tabbableView)
      else
        tabView.deselect()
    )

  togglePrincipalShortcut: (isTicketView) ->
    if isTicketView then @$el.find('#principal-selector').removeClass('hidden') else @$el.find('#principal-selector').addClass('hidden')
